import { Integration } from '@app/app/interfaces/integration.model';
import { Injectable } from '@angular/core';
import { Action, createSelector, Selector, State, StateContext } from '@ngxs/store';
import { IntegrationsService } from '@app/app/services/integrations.service';
import { GetIntegrations } from '@app/app/store/integrations/integrations.actions';
import { tap } from 'rxjs';
import { isBefore, subMinutes } from 'date-fns';

export interface IntegrationsStateModel {
  integrations: Integration[];
  lastFetch: number;
}

@State<Partial<IntegrationsStateModel>> ({
  name: 'Integrations',
  defaults: {
    integrations: [],
  }
})
@Injectable()
export class IntegrationsState {

  @Selector()
  static integrations(state: IntegrationsStateModel) {
    return state.integrations;
  }

  @Selector()
  static byId(integrationId: number) {
    return createSelector([IntegrationsState], state => {
      return state.Integrations?.integrations.find( integration => integration.customerIntegrationId === integrationId );
    });
  }

  constructor(
    private integrationsService: IntegrationsService,
  ) {}

  @Action( GetIntegrations )
  GetIntegrations(
    ctx: StateContext<IntegrationsStateModel>,
    { }: GetIntegrations
  ) {
    const lastFetch = ctx.getState().lastFetch;
    const stale = !lastFetch || isBefore(lastFetch, subMinutes(new Date(Date.now()), 5));
    if(stale) {
      return this.integrationsService.getIntegrations()
        .pipe(
          tap( response => {
            ctx.patchState({
              integrations: response.data,
              lastFetch: Date.now(),
            })
          })
        );
    }
  }
}
